import { combineReducers } from 'redux';
import { all, setContext } from 'redux-saga/effects';
import { ItineraryApiClient } from '../../api/itinerary';
import { MetricsApiClient } from '../../api/metrics';
import { AppState } from '../model';
import { ConfirmDialogReducer } from './confirm-dialog/reducer';
import { itineraryReducer } from './itinerary/reducer';
import { watcherSaga as itineraryActionWatcher } from './itinerary/sagas';
import { SegmentDetailsReducer } from './segment-details/reducer';
import { watcherSaga as segmentDetailsActionWatcher } from './segment-details/sagas';
import { SegmentOptionsReducer } from './segment-options/reducer';
import { SelectedOptionsReducer } from './selected-options/reducer';
import { watcherSaga as selectedOptionActionWatcher } from './selected-options/sagas';
import { SelectedRateReducer } from './selected-rate/reducer';
import { SelectedSegmentReducer } from './selected-segment/reducer';
import { watcherSaga as selectedSegmentActionWatcher } from './selected-segment/sagas';

const rootReducer = combineReducers<AppState>({
  itinerary: itineraryReducer,
  selectedOptions: SelectedOptionsReducer,
  selectedSegment: SelectedSegmentReducer,
  confirmDialog: ConfirmDialogReducer,
  segmentDetails: SegmentDetailsReducer,
  segmentOptions: SegmentOptionsReducer,
  selectedRate: SelectedRateReducer,
});

export default rootReducer;

interface RootSagaArguments {
  api: ItineraryApiClient;
  metricApi: MetricsApiClient;
}

export function* rootSaga(args: RootSagaArguments) {
  yield setContext(args);
  yield all([
    itineraryActionWatcher(),
    selectedSegmentActionWatcher(),
    segmentDetailsActionWatcher(),
    selectedOptionActionWatcher(),
    // metricsActionWatcher(),
  ]);
}
